import { useQuery } from "@tanstack/react-query";
import { QUERY_CONSTANTS } from "../queryKeys";
import { IReferralMembersParams } from "../types";
import { ReferralProgramService } from "../../services/referral-program.service";
import { IReferralMember } from "../../models/ReferralMember";
import { IReferralSettings } from "../../models/ReferralSettings";

export const useGetReferralSettingsQuery = () => {
  return useQuery<IReferralSettings, Error>({
    queryKey: [QUERY_CONSTANTS.GET_REFERRAL_SETTINGS],
    queryFn: () => ReferralProgramService.getReferralSettings().then((res) => res.data),
  });
};

export const useGetReferralMembersQuery = (data: IReferralMembersParams) => {
  return useQuery<{ members: IReferralMember[]; membersCount: number }, Error>({
    queryKey: [QUERY_CONSTANTS.GET_REFERRAL_MEMBERS, data],
    queryFn: () =>
      ReferralProgramService.getMembersWithPagination(data.currentPage, data.pageSize).then(
        (res) => res.data
      ),
  });
};
